import type { UsageEntry } from 'src/components/tailwind-components/ChatContextWindow/types';

const CONTEXT_USAGE_KEYS = ['context_window_usage', 'context_usage'] as const;

const isUsageEntry = (value: unknown): value is UsageEntry => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const row = value as Partial<UsageEntry>;
  return (
    typeof row.type === 'string' &&
    typeof row.tokens === 'number' &&
    Number.isFinite(row.tokens)
  );
};

// backend may send it as `context_window_usage` or `context_usage`
export const pickRawContextUsage = (
  source: Record<string, unknown> | undefined
): unknown => {
  for (const key of CONTEXT_USAGE_KEYS) {
    const value = source?.[key];
    if (Array.isArray(value) && value.length) {
      return value;
    }
  }
  return undefined;
};

export function extractContextUsage(raw: unknown): UsageEntry[] | undefined {
  if (!Array.isArray(raw)) {
    return undefined;
  }
  const entries = raw.filter(isUsageEntry);
  return entries.length ? entries : undefined;
}
